import { useSelector, useDispatch } from 'react-redux'
import { referenceDataUploadFeatureFlag } from 'apps/builder/store/selectors'
import { FancyRadio } from 'apps/builder/components/settings/modal'
import { updateEntry } from 'apps/builder/store/actions/entries'
import { WhiteLabelCheck } from 'apps/builder/components/shared'

export const ChoiceType = ({ guid, listType = 'type-my-own' }) => {
  const isRefDataEnabled = useSelector(referenceDataUploadFeatureFlag)
  const dispatch = useDispatch()

  const tooltip = (
    <>
      <div className="foundry--tooltip-text">
        You can set up custom lists by importing comma separated value (also
        called CSV) files
      </div>
      <WhiteLabelCheck>
        <a
          href="https://help.gocanvas.com/hc/en-us/sections/26599885125527-Reference-Data"
          className="foundry--link link--active link--wrap"
        >
          Learn how to create your file
        </a>
      </WhiteLabelCheck>
    </>
  )

  return (
    <div className="list-types">
      <FancyRadio
        id="type-my-own"
        value="type-my-own"
        label="Type my own"
        disabled={false}
        selected={listType}
        onChange={(checked, value) =>
          dispatch(updateEntry({ guid, listType: value }))
        }
      />
      {isRefDataEnabled && (
        <FancyRadio
          id="use-my-own-data"
          value="use-my-own-data"
          label={`Use my own data file `}
          disabled={false}
          selected={listType}
          onChange={(checked, value) =>
            dispatch(updateEntry({ guid, listType: value }))
          }
          tooltip={tooltip}
          tooltipDirection="bottom"
        />
      )}
    </div>
  )
}
